import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import Container from "components/container";
import SectionHeading from "components/sectionHeading";

const CenteredHeading = styled.h4`
  ${tw`text-center`}
`;
const HalfColCentered = styled.div`
  ${tw`text-center w-full mx-auto md:w-1/2 px-[15px]`}
`;

const Support = () => (
  <Container>
    <SectionHeading>Contact DwellSocial</SectionHeading>
    <CenteredHeading>We&#39;re happy to help!</CenteredHeading>
    <br />
    <HalfColCentered>
      <p>
        <a href="mailto:support@dwellsocial.zendesk.com">Email us</a> or click
        on the bubble in the bottom right corner to chat with us.
      </p>
    </HalfColCentered>
  </Container>
);

export default Support;
